if (typeof CustomImageHotspots !== 'function') {

  class CustomImageHotspots extends HTMLElement {

    constructor() {
      super();
      
      this.activeCard = null;
      this.init();
    }

init() {
  // Add click listeners to hotspot buttons
  this.querySelectorAll('[data-js-hotspot-index]').forEach(button => {
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      this.handleHotspotClick(e.currentTarget);
    });
  });

  // Add click listeners to close buttons
  this.querySelectorAll('[data-js-close-card]').forEach(closeBtn => {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      this.closeActiveCard();
    });
  });

  // Make product cards clickable only if they have links
  this.querySelectorAll('[data-js-hotspot-card]').forEach(card => {
    const hasLink = card.querySelector('a[href]');
    
    if (hasLink) {
      // Add clickable class for styling
      card.classList.add('hotspots__product-card--clickable');
      
      card.addEventListener('click', (e) => {
        e.stopPropagation();
        window.location.href = hasLink.href;
      });
    }

    // Always prevent closing when clicking inside the card
    card.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  });

  // Fixed click outside to close functionality
  this.documentClickHandler = (e) => {
    // Check if the clicked element is within this component
    if (!this.contains(e.target) && this.activeCard) {
      this.closeActiveCard();
    }
  };
  
  document.addEventListener('click', this.documentClickHandler);

  // Handle window resize for positioning
  this.resizeHandler = this.debounce(() => {
    if (this.activeCard) {
      this.adjustCardPosition(this.activeCard);
    }
  }, 200);
  
  window.addEventListener('resize', this.resizeHandler);

  // Position cards on load
  this.positionCards();
}

// Update the disconnectedCallback method:
disconnectedCallback() {
  if (this.resizeHandler) {
    window.removeEventListener('resize', this.resizeHandler);
  }
  if (this.documentClickHandler) {
    document.removeEventListener('click', this.documentClickHandler);
  }
}

    handleHotspotClick(button) {
      const buttonId = button.id;
      const cardId = buttonId.replace('spot-', 'spot-detail-');
      const card = this.querySelector(`#${cardId}`);
      
      if (!card) return;

      // If clicking the same hotspot, close it
      if (this.activeCard === card) {
        this.closeActiveCard();
        return;
      }

      // Close any currently active card
      this.closeActiveCard();

      // Activate new card
      this.activateCard(button, card);
    }

    activateCard(button, card) {
      // Add active classes
      button.classList.add('active');
      card.classList.add('active');
      
      // Set as active card
      this.activeCard = card;
      
      // Adjust positioning
      this.adjustCardPosition(card);
    }

    closeActiveCard() {
      if (!this.activeCard) return;

      // Remove active classes
      this.querySelectorAll('.active').forEach(element => {
        element.classList.remove('active');
      });

      // Clear active card reference
      this.activeCard = null;
    }

    adjustCardPosition(card) {
      const container = this.querySelector('.hotspots__image');
      const containerRect = container.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      
      // Reset position attributes
      card.removeAttribute('data-position');
      
      // Check if card goes beyond container boundaries
      const cardLeft = cardRect.left - containerRect.left;
      const cardRight = cardRect.right - containerRect.left;
      const cardTop = cardRect.top - containerRect.top;
      const cardBottom = cardRect.bottom - containerRect.top;
      
      // Adjust horizontal position
      if (cardLeft < 0) {
        card.setAttribute('data-position', 'left');
      } else if (cardRight > containerRect.width) {
        card.setAttribute('data-position', 'right');
      }
      
      // Adjust vertical position
      if (cardTop < 0) {
        card.setAttribute('data-position', 'top');
      } else if (cardBottom > containerRect.height) {
        card.setAttribute('data-position', 'bottom');
      }
    }

    positionCards() {
      // Initial positioning for all cards
      this.querySelectorAll('[data-js-hotspot-card]').forEach(card => {
        this.adjustCardPosition(card);
      });
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // Cleanup when element is removed
    disconnectedCallback() {
      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    }
  }

  // Define the custom element
  if (typeof customElements.get('custom-image-hotspots') === 'undefined') {
    customElements.define('custom-image-hotspots', CustomImageHotspots);
  }
}